import { isRouteErrorResponse, Link, useRouteError } from "react-router";

import { Button } from "@/components/ui/button";

/**
 * Rendered whenever a route loader, action or render throws. Route errors get
 * their status text; anything else is shown as a generic failure, with the
 * real message only in development.
 */
export default function ErrorBoundary() {
  const error = useRouteError();

  const { title, detail } = isRouteErrorResponse(error)
    ? {
        title: `${error.status} ${error.statusText}`,
        detail:
          error.status === 404
            ? "We couldn't find the page you were looking for."
            : "Something went wrong handling that request.",
      }
    : {
        title: "Unexpected error",
        detail:
          import.meta.env.DEV && error instanceof Error
            ? error.message
            : "Something went wrong. Try reloading the page.",
      };

  return (
    <div className="mx-auto flex min-h-dvh max-w-lg flex-col items-center justify-center gap-4 px-4 text-center">
      <h1 className="text-3xl font-semibold tracking-tight">{title}</h1>
      <p className="text-muted-foreground">{detail}</p>
      <Button asChild>
        <Link to="/">Back to home</Link>
      </Button>
    </div>
  );
}
